/** Rutas del PWA bajo /m/* con navegacion instantanea (design.md §22.1). */
import { Navigate, Route, Routes } from 'react-router-dom';
import { RequireMobileSession } from './RequireMobileSession';
import { HomePage } from '@/pages/m/HomePage';
import { DashboardPage } from '@/pages/m/DashboardPage';
import { TasksPage } from '@/pages/m/TasksPage';
import { TaskDetailPage } from '@/pages/m/TaskDetailPage';
import { ClientsPage } from '@/pages/m/ClientsPage';
import { RequirementsPage } from '@/pages/m/RequirementsPage';
import { RequirementNewPage } from '@/pages/m/RequirementNewPage';
import { RequirementDetailPage } from '@/pages/m/RequirementDetailPage';
import { RequirementEditPage } from '@/pages/m/RequirementEditPage';
import { BudgetsPage } from '@/pages/m/BudgetsPage';
import { BudgetDetailPage } from '@/pages/m/BudgetDetailPage';
import { QuoteGeneratorPage } from '@/pages/m/QuoteGeneratorPage';
import { MorePage } from '@/pages/m/MorePage';
import { TenantPage } from '@/pages/m/TenantPage';
import { LoginPage } from '@/pages/m/LoginPage';
import { ProfilePage } from '@/pages/m/ProfilePage';
import { ChangePasswordPage } from '@/pages/m/ChangePasswordPage';

export function MobileRoutes() {
  return (
    <Routes>
      <Route path="/m/login" element={<LoginPage />} />
      <Route
        path="/m/company"
        element={
          <RequireMobileSession>
            <TenantPage />
          </RequireMobileSession>
        }
      />
      <Route
        path="/m"
        element={
          <RequireMobileSession>
            <HomePage />
          </RequireMobileSession>
        }
      />
      <Route
        path="/m/dashboard"
        element={
          <RequireMobileSession>
            <DashboardPage />
          </RequireMobileSession>
        }
      />
      <Route
        path="/m/tasks"
        element={
          <RequireMobileSession>
            <TasksPage />
          </RequireMobileSession>
        }
      />
      <Route
        path="/m/tasks/:taskId"
        element={
          <RequireMobileSession>
            <TaskDetailPage />
          </RequireMobileSession>
        }
      />
      <Route
        path="/m/clients"
        element={
          <RequireMobileSession>
            <ClientsPage />
          </RequireMobileSession>
        }
      />
      <Route
        path="/m/requirements"
        element={
          <RequireMobileSession>
            <RequirementsPage />
          </RequireMobileSession>
        }
      />
      <Route
        path="/m/requirements/new"
        element={
          <RequireMobileSession>
            <RequirementNewPage />
          </RequireMobileSession>
        }
      />
      <Route
        path="/m/requirements/:id/edit"
        element={
          <RequireMobileSession>
            <RequirementEditPage />
          </RequireMobileSession>
        }
      />
      <Route
        path="/m/requirements/:id"
        element={
          <RequireMobileSession>
            <RequirementDetailPage />
          </RequireMobileSession>
        }
      />
      <Route
        path="/m/budgets"
        element={
          <RequireMobileSession>
            <BudgetsPage />
          </RequireMobileSession>
        }
      />
      <Route
        path="/m/budgets/:id"
        element={
          <RequireMobileSession>
            <BudgetDetailPage />
          </RequireMobileSession>
        }
      />
      <Route
        path="/m/quote-builder"
        element={
          <RequireMobileSession>
            <QuoteGeneratorPage />
          </RequireMobileSession>
        }
      />
      <Route
        path="/m/profile"
        element={
          <RequireMobileSession>
            <ProfilePage />
          </RequireMobileSession>
        }
      />
      <Route
        path="/m/password"
        element={
          <RequireMobileSession>
            <ChangePasswordPage />
          </RequireMobileSession>
        }
      />
      <Route
        path="/m/more"
        element={
          <RequireMobileSession>
            <MorePage />
          </RequireMobileSession>
        }
      />
      <Route path="*" element={<Navigate to="/m" replace />} />
    </Routes>
  );
}
